<template>
  <section>
    <h1 class="title">{{$t('new-registration', 'New registration')}}</h1>
    <div class="columns">
      <div class="column is-one-third">
        <registration-form
          @onSubmitRegistration="createRegistration"
          showSubmit
        />
        <p v-if="isSubmittingRegistration">
          <font-awesome-icon icon="circle-notch" spin fixed-width />&nbsp;{{$t('submitting-registration', 'Submitting registration...')}}
        </p>
        <div v-if="submitError" class="notification is-danger">
          <strong>Error</strong>
          <p>{{$t('error-submit-registration', { replace: { submitError }, defaultValue: `An error occurred when submitting the registration: ${ submitError }` } )}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api'
import RegistrationForm from '@/components/RegistrationForm.vue'

export default {
  name: 'NewRegistration',
  components: { RegistrationForm },
  data () {
    return {
      isSubmittingRegistration: false,
      submitError: undefined
    }
  },
  methods: {
    createRegistration (registration) {
      this.isSubmittingRegistration = true
      this.submitError = undefined

      api.productRegister
        .create(registration)
        .then((res) => {
          const message = this.$t('submit-registration-success', {
            replace: { company: registration.company },
            defaultValue: `Successfully created new registration for: ${registration.company}`
          })
          this.$notifySuccess(undefined, message)
          this.$router.push('/registrations')
        })
        .catch((err) => {
          this.submitError = err
        })
        .finally(() => {
          this.isSubmittingRegistration = false
        })
    }
  }
}
</script>
